import _styled from '@emotion/styled/base';
import { Flex } from '../../Flex/index.js';
import { VISUAL_ELEMENT_SIZE_MAP } from '../shared/constants.js';

const VisualElementPairWrapper = _styled(Flex, {
  shouldForwardProp: prop => prop !== 'size',
  target: "e2eob4k2"
})("height:", ({
  size
}) => VISUAL_ELEMENT_SIZE_MAP[size], ";width:", ({
  size
}) => VISUAL_ELEMENT_SIZE_MAP[size], ";position:relative;img{max-width:100%;}");
const SvgWrapper = _styled("svg", {
  target: "e2eob4k1"
})({
  name: "w1atjl",
  styles: "width:100%;height:100%"
} );
const PairWrapper = _styled("div", {
  target: "e2eob4k0"
})({
  name: "11vq21k",
  styles: "position:absolute;bottom:-4px;right:-4px"
} );

export { PairWrapper, SvgWrapper, VisualElementPairWrapper };
